import { FC } from "react";
import { DisplayText, Modal, Paragraph, Stack, Table } from "@contentful/f36-components";
import { GlossaryRow } from "..";
import { GlossaryId } from "../../lib";
import { GlossaryModalProps } from "./ImportGlossaryModal";

interface EditGlossariesModalProps extends GlossaryModalProps {
    savedGlossaryId?: GlossaryId;
}

export const EditGlossariesModal: FC<EditGlossariesModalProps> = ({
    isShown,
    setIsShown,
    glossaries,
    savedGlossaryId,
}) => {
    return (
        <Modal
            title="Edit glossaries"
            size="large"
            isShown={isShown}
            onClose={() => setIsShown(false)}>
            {glossaries.length === 0 ? (
                <DisplayText fontSize="fontSizeXl">No glossaries to be displayed</DisplayText>
            ) : (
                <Stack flexDirection="column" alignItems="start">
                    <Paragraph>
                        If entries have been <strong>added</strong> or <strong>removed</strong> in
                        your DeepL glossary and you'd like to apply these changes in Linguiny, just
                        re-download the glossary from DeepL and click the upload button here to
                        import the new version.
                    </Paragraph>
                    <Table>
                        <Table.Head>
                            <Table.Row>
                                <Table.Cell>Name</Table.Cell>
                                <Table.Cell>Languages</Table.Cell>
                                <Table.Cell>Entries</Table.Cell>
                                <Table.Cell>Last updated</Table.Cell>
                                <Table.Cell />
                            </Table.Row>
                        </Table.Head>
                        <Table.Body>
                            {glossaries
                                .sort((a, b) => b.lastUpdated.localeCompare(a.lastUpdated))
                                .map((glossary, index) => (
                                    <GlossaryRow
                                        glossary={glossary}
                                        key={index}
                                        isSaved={savedGlossaryId === glossary.id}
                                    />
                                ))}
                        </Table.Body>
                    </Table>
                    <br />
                </Stack>
            )}
        </Modal>
    );
};
